import React from "react";
import styles from "./AddLoanRegister.module.css";
import { CloseButton } from "../../../fixedassetelements/button/Button";
import ExcelImage from "../../../assets/icons/MultipleExcelSheets.png";
import ERPImage from "../../../assets/icons/ErpPackage.png";

const AddLoanRegister = ({ onClose, handleSelect }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <div className={styles.header}>
          <h3 className={styles.heading}>Add Loans Register</h3>
          <CloseButton onClick={onClose} />
        </div>

        <div className={styles.content}>
          <div
            className={styles.cardContainer}
            onClick={() => handleSelect("uploadExcelModal")}
          >
            <div className={styles.imageWrapper}>
              <img
                src={ExcelImage}
                alt="Upload Excel"
                className={styles.cardImage}
              />
            </div>
            <div className={styles.belowContainer}>
              <h4 className={styles.cardTitle}>Upload as Excel File</h4>
              <p className={styles.cardDescription}>
                Upload your TB from xlsx, csv files and map column headers to continue.
              </p>
            </div>
          </div>

          <div
            className={styles.cardContainer}
            onClick={() => handleSelect("erp")}
          >
            <div className={styles.imageWrapper}>
              <img
                src={ERPImage}
                alt="Pull from ERP"
                className={styles.cardImage}
              />
            </div>
            <div className={styles.belowContainer}>
              <h4 className={styles.cardTitle}>Pull from ERP</h4>
              <p className={styles.cardDescription}>
                Link TB data from your ERP packages and seamlessly flow your data
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddLoanRegister;
